import axios from "axios";
// let base = "http://localhost:8000/api"
 if (process.env.NODE_ENV === 'development') {
  //  base = location.protocol+'localhost:8000/api'
  //axios.defaults.baseURL = 'http://192.168.1.114:8000/api'
  axios.defaults.baseURL = 'http://localhost:8000/api'
  //'http://localhost/laravelbm/server.php/api'
 }else{
  //  base = window.location.origin+'/tss/server.php/api'
  axios.defaults.baseURL = window.location.origin+'/laravelbm/server.php/api'
 }
export default axios.create({ 
  baseURL: undefined, 
  
  
  headers: {
    "Content-type": "application/json",
  }
});